"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _LoadingIndicator = _interopRequireDefault(require("../LoadingIndicator"));
/** Buttons with animations showing when a tool is working */


var SubmitButton = function SubmitButton(_ref) {
  var isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      block = _ref.block,
      buttonStyle = _ref.buttonStyle,
      children = _ref.children,
      className = _ref.className,
      htmlId = _ref.htmlId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["isLoading", "loadingText", "block", "buttonStyle", "children", "className", "htmlId"]);
  var loadingIndicatorColor = buttonStyle === "primary" || buttonStyle === "danger" ? "white" : "gray";
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({
    className: (0, _classnames["default"])([isLoading && "btn--loader", className]),
    disabled: isLoading,
    type: "submit"
  }, (0, _objectSpread2["default"])({
    block: block,
    buttonStyle: buttonStyle,
    htmlId: htmlId
  }, props)), isLoading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
    htmlId: "".concat(htmlId, "-loading-indicator"),
    size: "small",
    color: loadingIndicatorColor
  }), loadingText && /*#__PURE__*/_react["default"].createElement("span", {
    className: "loading-text"
  }, loadingText)) : children);
};

SubmitButton.defaultProps = {
  block: false,
  buttonStyle: "primary",
  size: "default"
};
var _default = SubmitButton;
exports["default"] = _default;